import React from 'react'
import "./Extra_income.css";

export default function Extra_income() {
    return (
        <section className='home-income'>
            <div className='container'>
                <div className='row income'>
                    <div className='col-12 col-md-6 col-sm-6 col-lg-6 left-div'>
                        <div className='Info'>
                            <h1>Looking for an Extra Income?</h1>
                            <h6>Are you one of the millions of people looking for extra income?</h6>
                            <p>You're not alone. Rising costs, stagnant wages, and the desire for
                                greater financial security are driving more & more people to seek
                                additional income streams. But juggling a second job with existing
                                commitments can be exhausting and unsustainable.</p>
                        </div>
                    </div>
                    <div className='col-12 col-md-6 col-sm-6 col-lg-6 right-div'>
                        <img src={process.env.PUBLIC_URL + '/Assets/Images/extra_income/banner/Extra_income_banner.png'} alt='' className='income_banner' />

                    </div>
                </div>

            </div>
        </section>

    )
}
